import type { UniclientBaseComponentProps, UniclientWizardComponentBase } from './types';

export type ProductStatus = 'active' | 'cancelled' | 'future';

interface ProductInfo {
  readonly id: string;
  readonly status: ProductStatus;
  readonly date?: string;
}

export type ProductSummaryProps = UniclientBaseComponentProps & {
  readonly title: string;
  readonly thumbnail: string;
  readonly subtitle?: string;
  readonly disclaimer?: ProductInfo | string;
  readonly hasLargerPadding?: boolean;
};

export type UniclientProductSummaryProps = ProductSummaryProps & UniclientWizardComponentBase<'productSummary'>;

export function productSummary(props: ProductSummaryProps): UniclientProductSummaryProps {
  return { ...props, type: 'productSummary' };
}
